import { render, staticRenderFns } from "./StudentProfileTutorComment.vue?vue&type=template&id=7037a15a&scoped=true&"
import script from "./StudentProfileTutorComment.vue?vue&type=script&lang=js&"
export * from "./StudentProfileTutorComment.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileTutorComment.vue?vue&type=style&index=0&id=7037a15a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7037a15a",
  null
  
)

export default component.exports